"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_bootstrap_1 = require("react-bootstrap");
const FontAwesome = require('react-fontawesome');
class LoadingSpinner extends React.Component {
    render() {
        return React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { mdOffset: 5, md: 2 }, React.createElement(FontAwesome, { name: "spinner", spin: true })));
    }
}
exports.default = LoadingSpinner;


//////////////////
// WEBPACK FOOTER
// ./client/src/shared/LoadingSpinner.tsx
// module id = 1072
// module chunks = 0 1 2